import * as yup from 'yup';
import { TranslateFn, optionalText, requiredText } from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';

/** The two lengths the API enforces, so the field complains before the round trip does. */
const LINE_MAX = 255;
const PARAGRAPH_MAX = 500;
const BODY_MAX = 2000;

/**
 * The front page as its admin types it.
 *
 * <b>One line is required: the headline's first, in Romanian.</b> It is what the page is
 * about; without it the hero is a band of colour. Every other line is optional, because a
 * blank one is simply not on the page, and clearing a field is how an admin takes a line off.
 *
 * A card, once it exists, needs its Romanian title and text: a blank one would still be drawn,
 * as a blank card on a shopfront. English is optional throughout and falls back to Romanian,
 * which is the rule every clinic-written surface follows and the one the API enforces.
 */
export const createHomeSchema = (translate: TranslateFn) => yup.object({
    heroEyebrowRo: optionalText(translate, LINE_MAX),
    heroEyebrowEn: optionalText(translate, LINE_MAX),
    heroHeadline1Ro: requiredText(translate, ResourcesIds.HOME_HEADLINE_REQUIRED, LINE_MAX),
    heroHeadline1En: optionalText(translate, LINE_MAX),
    heroHeadline2Ro: optionalText(translate, LINE_MAX),
    heroHeadline2En: optionalText(translate, LINE_MAX),
    heroSubtitleRo: optionalText(translate, PARAGRAPH_MAX),
    heroSubtitleEn: optionalText(translate, PARAGRAPH_MAX),
    featuresEyebrowRo: optionalText(translate, LINE_MAX),
    featuresEyebrowEn: optionalText(translate, LINE_MAX),
    featuresTitleRo: optionalText(translate, LINE_MAX),
    featuresTitleEn: optionalText(translate, LINE_MAX),
    featuresSubtitleRo: optionalText(translate, PARAGRAPH_MAX),
    featuresSubtitleEn: optionalText(translate, PARAGRAPH_MAX),
    ctaTitleRo: optionalText(translate, LINE_MAX),
    ctaTitleEn: optionalText(translate, LINE_MAX),
    ctaSubtitleRo: optionalText(translate, PARAGRAPH_MAX),
    ctaSubtitleEn: optionalText(translate, PARAGRAPH_MAX),
    cards: yup.array().of(
        yup.object({
            key: yup.string().defined(),
            icon: yup.string().defined(),
            titleRo: requiredText(translate, ResourcesIds.HOME_CARD_TITLE_REQUIRED, LINE_MAX),
            titleEn: optionalText(translate, LINE_MAX),
            bodyRo: requiredText(translate, ResourcesIds.HOME_CARD_BODY_REQUIRED, BODY_MAX),
            bodyEn: optionalText(translate, BODY_MAX),
        }).defined()
    ).defined(),
});
